/**
 * Expected minutes per question type for section planning totals.
 *
 * Same map the paper roster (`SectionCard` / `QuestionListItem`) uses so a
 * section reports one duration whether the author is on the assessment page or
 * in Add questions.
 */

export const EXPECTED_TIME_BY_TYPE: Record<string, number> = {
  "Multiple Choice": 1.5,
  "Multiple Select": 2.5,
  Hotspot: 3.0,
  "Fill in the blank": 2.0,
  "True or False": 1.0,
  Essay: 8.0,
  "Match the following": 4.0,
  "Short Answer": 2.0,
}

export function expectedMinutesForQuestionType(type: string): number {
  return EXPECTED_TIME_BY_TYPE[type] ?? 2.0
}

export function sectionEstimatedMinutes(
  rows: ReadonlyArray<{ type: string }>
): number {
  const total = rows.reduce(
    (sum, row) => sum + expectedMinutesForQuestionType(row.type),
    0
  )
  return Number(total.toFixed(1))
}
